module.exports = "<div class=container-fluid> <div class=subfooter__feature> <div class=\"row no-gutters\"> <div class=col-6 ng-repeat=\"features in $ctrl.shCtrl.globalBanners.store_features.items\"> <div class=feature__block layout=column layout-align=\"center center\"> <img ng-src={{features.imageUrl}} title={{features.title}} class=center-block> </div> </div> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/store-features/templates/store-features-adaptative.view.html
 ** module id = 904
 ** module chunks = 7
 **/